import moment from "moment";

export const COLUMNS =[
    {
        Header      : '#',
        accessor    : 'orgCode',
        Cell: props => <span key={props.value}>{props.value}</span>,
        disableFilters:true
    },
    {
        Header      : 'Client',
        accessor    : 'orgName',
       
    },
    // {
    //     Header      : 'Location',
    //     accessor    : 'address',
    //     Cell: (row) => {
    //         /* Add data-tip */
    //         return <span data-tip={row.value}>{row.value.length >15 ?row.value.slice(0,14)+"..." :row.value}</span>;
    //       },
    //     disableFilters:true
    // },
    {
        Header      : 'Executive Support',
        accessor    : 'executiveSupport.userName',
       
    },
    {
        Header      : 'Secretariate',
        accessor    : 'secretariate',
       
    },
    {
        Header      : 'Lead Auditor',
        accessor    : 'leadAuditor.userName',
       
    },
    {
        Header      : 'Asstitant Auditor',
        accessor    : 'assitAuditor.userName',
       
    },
    {
        Header      : 'Technical Expert',
        accessor    : 'technicalexpert',
       
    },
    {
        Header      : 'Manager',
        accessor    : 'managerName',
       
    },
    {
        Header      : 'Client Spoc',
        accessor    : 'client.userName',
       
    },
    // {
    //     Header      : 'Date of Audit',
    //     accessor    : moment('dateofaudit').format("dd-MMM-YYYY"),
       
    // },
    
    
]